 const data=[
    {    id:1, 
         img:"https://i.ibb.co/gFHzs3k/download-1-removebg-preview.png",
         name:"C1 Headphones",
         title:"Html & Css",
         price:300,
         quantity:1,
     },
     {   id:2, 
        img:"https://i.ibb.co/LZ0JPTm/images-removebg-preview.png",
        name:"AK Headphones",
        title:"Canva & AdobePhotoShoot",
        price:299,
        quantity:1,
    },
    {   id:3, 
        img:"https://i.ibb.co/DCnp2SX/download-4-removebg-preview.png",
        name:"C7 Headphones",
        title:"Canva & AdobePhotoShoot",
        price:29,
        quantity:1,
    },
    {   id:4, 
        img:"https://i.ibb.co/Sfp281q/download-removebg-preview.png",
        name:"ReL Headphones",
        title:"Canva & AdobePhotoShoot",
        price:50,
        quantity:1,
    },
    {   id:5, 
        img:"https://i.ibb.co/gtgJ5Nm/images-2-removebg-preview.png",
        name:"Gek Headphones",
        title:"Canva & AdobePhotoShoot",
        price:140,
        quantity:1,
    },
    {   id:6, 
        img:"https://i.ibb.co/vJ4TR59/images-4-removebg-preview.png",
        name:"MK Headphones",
        title:"Canva & AdobePhotoShoot",
        price:70,
        quantity:1,
    }
    ,
    {   id:7, 
        img:"https://i.ibb.co/DCnp2SX/download-4-removebg-preview.png",
        name:"ZA Headphones",
        title:"Canva & AdobePhotoShoot",
        price:31,
        quantity:1,
    },
    {   id:8, 
        img:"https://i.ibb.co/LZ0JPTm/images-removebg-preview.png",
        name:"G9 Headphones",
        title:"Canva & AdobePhotoShoot",
        price:100,
        quantity:1,
    },
    {   id:9, 
        img:"https://i.ibb.co/hHgyDJw/download-3-removebg-preview.png",
        name:"E1 Headphones",
        title:"Canva & AdobePhotoShoot",
        price:120,
        quantity:1,
    },
    {    id:10, 
        img:"https://i.ibb.co/gFHzs3k/download-1-removebg-preview.png",
        name:"C1 Headphones",
        title:"Html & Css",
        price:99,
        quantity:1,
    },
     {   id:11, 
        img:"https://i.ibb.co/gtgJ5Nm/images-2-removebg-preview.png",
        name:"Gek Headphones",
        title:"Canva & AdobePhotoShoot",
        price:101,
        quantity:1,
    },
    {   id:12, 
        img:"https://i.ibb.co/vJ4TR59/images-4-removebg-preview.png",
        name:"MK Headphones",
        title:"Canva & AdobePhotoShoot",
        price:112,
        quantity:1,
    }
  
    
    
]
export default data